/*
 * @Description:订单项目路由管理文件
 * @Author: 王振
 * @Date: 2021-05-28 14:47:42
 * @LastEditors: 王振
 * @LastEditTime: 2022-03-08 12:36:25
 */

import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import NProgress from "nprogress"; // 进度条
import "nprogress/nprogress.css"; // 进度条样式
import { getToken } from "@/utils/auth"; // 从cookie获取token

NProgress.configure({ showSpinner: false }); // 进度条配置

const whiteList = ["/login"]; // 重定向白名单

Vue.use(Router);

//配置路由
const routes = [
  {
    path: "/",
    name: "order",
    component: (resolve) => require(["@/pages/system/view/order.vue"], resolve),
  },
  {
    path: "/login",
    name: "login",
    component: (resolve) => require(["@/pages/system/view/login.vue"], resolve),
  },
];

// 创建 router 实例，然后传 `routes` 配置
const router = new Router({
  mode: "hash", // 强制使用hash模式进行导航，不能指望服务器支持history
  routes, // （缩写）相当于 routes: routes
});

router.beforeEach(async (to, from, next) => {
  // 进度条开始
  NProgress.start();

  // 判断用户是否登录
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      // 如果已登录，重定向到主页
      next({ path: "/" });
      NProgress.done();
    } else {
      const hasGetUserInfo = store.getters.userInfo;
      // console.log("file: index.js ~ line 56 ~ hasGetUserInfo", hasGetUserInfo);
      if (Object.keys(hasGetUserInfo).length != 0) {
        next();
      } else {
        try {
          // 获取用户信息
          await store.dispatch("user/getInfo");
          next();
        } catch (error) {
          // 重置token，并重定向到登录页面，重新登录
          await store.dispatch("user/resetToken");
          Message.error(error || "Has Error");
          next(`/login?redirect=${to.path}`);
          NProgress.done();
        }
      }
    }
  } else {
    /* 用户未登录*/

    if (whiteList.indexOf(to.path) !== -1) {
      // 在白名单中，直接进入
      next();
    } else {
      // 其他没有访问权限的页面将重定向到登录页面
      next(`/login?redirect=${to.path}`);
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  // 进度条结束
  NProgress.done();
});

//导出路由
export default router;



// WEBPACK FOOTER //
// ./src/pages/system/router/index.js